 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import EPUB4211 from '@/components/Epub4211'
 import GROVEATLANTICLITHUB from '@/components/groveatlanticlithub'
 import LOVE_1 from '@/components/love_1'
 import EPUB42111 from '@/components/Epub42111'
 import EPUB42112 from '@/components/Epub42112'
 import EPUB42113 from '@/components/Epub42113'
 import EPUB42114 from '@/components/Epub42114'
 import EPUB42115 from '@/components/Epub42115'
 import EPUB42116 from '@/components/Epub42116'
 import EPUB42117 from '@/components/Epub42117'
 import EPUB42118 from '@/components/Epub42118'
 import EPUB42119 from '@/components/Epub42119'
 import EPUB421110 from '@/components/Epub421110'
 import EPUB421111 from '@/components/Epub421111'
 import EPUB421112 from '@/components/Epub421112'
 import LOVE_2 from '@/components/love_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Epub4211",
 			"name" : "Epub4211",
 			"component" : EPUB4211
 		},
 		{
 			"path" : "/groveatlanticlithub",
 			"name" : "groveatlanticlithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Epub42111",
 			"name" : "Epub42111",
 			"component" : EPUB42111
 		},
 		{
 			"path" : "/Epub42112",
 			"name" : "Epub42112",
 			"component" : EPUB42112
 		},
 		{
 			"path" : "/Epub42113",
 			"name" : "Epub42113",
 			"component" : EPUB42113
 		},
 		{
 			"path" : "/Epub42114",
 			"name" : "Epub42114",
 			"component" : EPUB42114
 		},
 		{
 			"path" : "/Epub42115",
 			"name" : "Epub42115",
 			"component" : EPUB42115
 		},
 		{
 			"path" : "/Epub42116",
 			"name" : "Epub42116",
 			"component" : EPUB42116
 		},
 		{
 			"path" : "/Epub42117",
 			"name" : "Epub42117",
 			"component" : EPUB42117
 		},
 		{
 			"path" : "/Epub42118",
 			"name" : "Epub42118",
 			"component" : EPUB42118
 		},
 		{
 			"path" : "/Epub42119",
 			"name" : "Epub42119",
 			"component" : EPUB42119
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js